'use client';
import { clsx } from 'clsx';
import { IconClose } from 'components/ui/icons/player';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'store/hooks';
import { closeOverlay, getOverlay, setCurrrenSection } from 'store/slices/overlay.slices';
import { listSections } from './constants';
import { Podcasts } from './podcasts';
import { RadioBroadcast } from './radio-broadcast';
import styles from './overlay.module.scss';
import { useEffect, useState } from 'react';

export const Overlay = () => {
  const dispath = useDispatch();

  const [animation, setАnimation] = useState<boolean>(false);

  const { isOpen, currrenSection } = useAppSelector(getOverlay);

  const onClose = () => dispath(closeOverlay());

  /* Всплытие окна с анимацией */
  useEffect(() => {
    isOpen ? setTimeout(() => setАnimation(true), 0) : setАnimation(false);
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <aside className={clsx(styles.pick, { [styles.active]: animation })}>
          <header className={styles.header}>
            {listSections.map((item, i) => (
              <button
                onClick={() => dispath(setCurrrenSection(item))}
                key={i}
                className={clsx(styles.item, {
                  [styles.active]: currrenSection === item,
                })}
              >
                {item}
              </button>
            ))}
            <button onClick={onClose} className={styles.close}>
              <IconClose />
            </button>
          </header>
          <section>
            {currrenSection === 'Радиоэфир' && <RadioBroadcast />} {/* Окно радиоэфир */}
            {currrenSection === 'Программы' && <Podcasts />} {/* Окно программы */}
          </section>
        </aside>
      )}
    </>
  );
};
